import { useMemo } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { CardEarnList } from "./hooks";
import styles from "./styles.module.scss";

interface EarnBreakdownCardProps {
  title: string;
  earnList: CardEarnList;
}

export const EarnBreakdownCard: React.FC<EarnBreakdownCardProps> = ({
  title,
  earnList,
}: EarnBreakdownCardProps) => {
  const { t } = useI18nContext();
  const [, cn] = useModuleBEM(styles, "PremierDestinationEarnDialog");

  const sortedEarnList = useMemo(() => {
    const earnListArray = Object.keys(earnList).map((key) => ({
      ...earnList[key],
      key,
    }));

    return earnListArray.sort((a, b) => {
      const earnRateA = parseFloat(a.key);
      const earnRateB = parseFloat(b.key);

      return earnRateA < earnRateB ? 1 : -1;
    });
  }, [earnList]);

  return (
    <div className={cn("earn-container")}>
      <div className={cn("earn-row")}>
        <div className={cn("earn-header-card")}>{t("hsbcCard")}</div>
        <div className={cn("earn-header-rate")}>{title}</div>
      </div>

      {sortedEarnList.map(({ cardNames, rate }) => (
        <div className={cn("earn-row")}>
          <ul className={cn("earn-card-list")}>
            {cardNames.map((card, index) => (
              <li key={`${card}-${index}`} className={cn("earn-card-item")}>
                {card}
              </li>
            ))}
          </ul>

          <div className={cn("earn-rate")}>{rate}</div>
        </div>
      ))}
    </div>
  );
};
